import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  checkIfDemoUserExist,
  demoLogin,
  forgotPassword,
  loginUser,
  resetPassword,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { APP_CONST } from "../../../config/const";

import PhoneInput from "react-phone-input-2";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import BackArrow from "../../../assets/svg/back-arrow.svg";
import { useTranslation } from "react-i18next";
import RegisterBanner from "../../../assets/images/banner/mob-signup.png";
import WtspChannel from "../../../assets/images/icons/social/Whatsapp.svg";
import Telegram from "../../../assets/images/icons/social/Telegram.svg";
import Instagram from "../../../assets/images/icons/social/Instagram.svg";
import Facebook from "../../../assets/images/icons/social/facebook.svg";
import Twitter from "../../../assets/images/icons/social/Twitter.svg";
import YouTube from "../../../assets/images/icons/YouTube.png";
import Android from "../../../assets/images/icons/android-apk.webp";
import ArrowDown from "../../../assets/images/icons/arrow-down.webp";
import { a } from "react-router-dom";
import { useApkEnvHook } from "../../../hooks/useApkEnvHook";

const LoginModal = ({ show, handleClose, handleModalShow }) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");
  const [changeModalContent, setChangeModalContent] = useState(true);
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isDemoUserExist, setIsDemoUserExist] = useState(false);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;
  const { isApkEnv } = useApkEnvHook();

  const { t } = useTranslation();

  useEffect(() => {
    checkDemoUser();
  }, []);

  const checkDemoUser = async () => {
    const response = await checkIfDemoUserExist();
    if (response && response?.data?.error === false) {
      setIsDemoUserExist(response?.data?.data?.hasDemoUsers === true);
    }
  };
  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = t("username_cannot_be_empty");
    }
    if (!password || password === "") {
      newErrors.password = t("password_cannot_be_empty");
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();
    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      let loginData = { ...formData };
      // handleClose();
      dispatch(loginUser(loginData));
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  const handleSubmitForgotPass = async (e) => {
    e.preventDefault();

    let payload = {};
    if (email?.email || mobileNumber) {
      if (isEmailOtpRequired) {
        payload.email = email?.email;
      } else {
        const phoneNumber = parsePhoneNumber("+" + mobileNumber);

        payload.phone = phoneNumber.nationalNumber;
        payload.countryCode = phoneNumber.countryCallingCode;
      }
      forgotPassword(payload)
        .then((res) => {
          if (res.data.error === false) {
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("OTP_sent"));
            setIsOtpSent(true);
            // navigate("/reset-password");
            // handleClose();
            // handleModalShow(APP_CONST.AUTH_MODAL.RESET_PASSWORD);
          }
        })
        .catch((err) => {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
        });
    } else {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        isEmailOtpRequired
          ? t("please_enter_email")
          : t("please_enter_mobile_number")
      );
    }
  };

  const handleSubmitResetPass = () => {
    setIsVerifying(true);

    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, t("all_fields_are_mandatory"));
    } else {
      const payload = {
        otp,
        password,
      };

      resetPassword(payload)
        .then((res) => {
          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("password_reset_success"));
          // navigate("/sign-in");
          // handleClose();
          // handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
          setChangeModalContent((prev) => !prev);
        })
        .catch((err) => {
          Toaster(
            APP_CONST.TOAST_TYPE.ERROR,
            err.response.data.message || t("request_failed")
          );
          setIsVerifying(false);
        });
    }
  };

  const handleDemoLogin = () => {
    dispatch(demoLogin());
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas lgn-reg-modal login"}
      onHide={() => {
        console.log("working");
      }}
      centered
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      ></Modal.Header>
      <Modal.Body>
        {changeModalContent ? (
          <div
            className={
              !changeModalContent ? `login-section` : `login-section active`
            }
          >
            <div className="Login-rightPart">
              <div className="inner-wrapper">
                <div className="left-banner-login d-none d-lg-block"></div>
                <div className="right-content">
                  {/* <Modal.Title>{t("login")}</Modal.Title> */}
                  <div className="register-banner d-lg-none ">
                    <img src={RegisterBanner} alt="sign up banner pinkybet" />
                  </div>
                  {/* <div className="welcome">Welcome to Fairbet</div> */}

                  <div className="back-demo">
                    <h2 className="title">Login</h2>
                    {/* {isDemoUserExist && (
                    <>
                      <div className="demobutton">
                        <div
                          className="mt-1 btn btn-primary demologin"
                          onClick={handleDemoLogin}
                        >
                          Demo Login
                        </div>
                      </div>
                    </>
                  )} */}
                  </div>
                  <h6 className="sub-title">
                    Please enter your login details here.
                  </h6>
                  <div className="form-steps">
                    <Form>
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicName"
                      >
                        <Form.Control
                          type="text"
                          placeholder={t("username *")}
                          name="username"
                          onChange={handleChange}
                          isInvalid={!!errors.username}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.username}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        className="position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder={t("password *")}
                          name="password"
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                        />
                        <span
                          className="icon"
                          onClick={() => setShowPassword((s) => !s)}
                        >
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                        <Form.Control.Feedback type="invalid">
                          {errors?.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div className="frgt-pwd">
                        <a
                          onClick={() => {
                            // handleClose();
                            // handleModalShow(APP_CONST.AUTH_MODAL.FORGOTO_PASSWORD);
                            setChangeModalContent((prev) => !prev);
                          }}
                        >
                          {t("forgot_password")}
                        </a>
                      </div>
                      <Button
                        variant="primary"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        {t("login")}
                      </Button>
                    </Form>

                    {/* <div className="register-back">
                    <span>{t("still_no_account")}</span>
                    <a
                      href="#"
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                        handleClose(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      {t("register")}
                    </a>
                  </div> */}
                  </div>
                  {!isApkEnv() && (
                    <div className="download-apk">
                      <a href="" download="">
                        <img src={Android} alt="android pinkybet" />
                        <span>Download .apk Android</span>
                        <img
                          src={ArrowDown}
                          alt="arrow down pinkybet"
                          className="arrow"
                        />
                      </a>
                    </div>
                  )}
                  {isDemoUserExist && (
                    <div className="download-apk mt-5">
                      <a href="#" onClick={handleDemoLogin}>
                        <span> Demo Login</span>
                      </a>
                    </div>
                  )}

                  <div className="account-signin-signup">
                    Don't have account?&nbsp;
                    <br />
                    <div
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                        handleClose(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                    >
                      <p>Sign Up</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={
              changeModalContent
                ? `login-section`
                : `login-section ForgotPasswordSection`
            }
          >
            <div className="Login-rightPart">
              {/* <Modal.Title>{t("password_recovery")}</Modal.Title> */}
              {/* <div className="left-banner d-none d-lg-block"></div> */}
              <div className="inner-wrapper">
                <div className="left-banner-login d-none d-lg-block"></div>
                <div className="password-content">
                  <div className="back-demo">
                    <h2 className="title">{t("password_recovery")}</h2>
                  </div>
                  <h6 className="sub-title">{t("reset_password_content")}</h6>
                  {/* <div className="welcome"></div> */}
                  <div className="form-steps">
                    <Form>
                      {!isEmailOtpRequired && (
                        <Form.Group
                          className="mb-4 position-relative"
                          controlId="formBasicPassword"
                        >
                          <PhoneInput
                            country={"in"}
                            countryCodeEditable={false}
                            inputProps={{
                              name: "phone",
                            }}
                            // onlyCountries={["in"]}
                            inputStyle={{
                              width: "100%",
                            }}
                            onChange={(phone) => {
                              // alert("phone", phone);
                              // alert(phone);
                              setMobileNumber(phone);
                            }}
                          />
                        </Form.Group>
                      )}
                      {isEmailOtpRequired && (
                        <Form.Group
                          className="mb-3 position-relative"
                          controlId="formBasicPassword"
                        >
                          <Form.Control
                            type="email"
                            placeholder={t("enter_email *")}
                            value={email.email}
                            onChange={(e) =>
                              setEmail({ email: e.target.value })
                            }
                          />
                        </Form.Group>
                      )}
                      <Button
                        variant="primary mb-4"
                        type="submit"
                        onClick={handleSubmitForgotPass}
                      >
                        {t("get_OTP")}
                      </Button>

                      <Form.Group
                        className="mb-4 position-relative"
                        controlId=""
                      >
                        <Form.Control
                          type="text"
                          placeholder={t("enter_OTP *")}
                          onChange={(e) => setOtpValue(e.target.value)}
                          autoComplete="off"
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-4 position-relative"
                        controlId=""
                      >
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder={t("enter_new_password")}
                          onChange={(e) => setPassword(e.target.value)}
                          autoComplete="new-password"
                        />
                        <span
                          className="icon"
                          onClick={() => setShowPassword((s) => !s)}
                        >
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                      </Form.Group>

                      <div className="sbmt-back">
                        <a
                          href="#"
                          className="back-btn"
                          onClick={() => setChangeModalContent((prev) => !prev)}
                        >
                          <img src={BackArrow} alt="back" />
                        </a>
                        <Button
                          variant="primary"
                          onClick={handleSubmitResetPass}
                          disabled={!isOtpSent}
                        >
                          {!isVerifying ? t("submit") : t("submitting")}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
